import React, { useEffect } from 'react';
import TablePagination from '@material-ui/core/TablePagination';

export default function PaginationControlled ({
  tableLength = 1,
  updateRowCount,
  rowsPerPageOptions = [25, 50, 75, 100],
  pageNo,
  rowsPerPagination
}) {
  const [page, setPage] = React.useState(pageNo);
  const [rowsPerPage, setRowsPerPage] = React.useState(rowsPerPagination);

  useEffect(() => {
    setPage(pageNo);
  }, [pageNo]);

  useEffect(() => {
    setRowsPerPage(rowsPerPagination);
  }, [rowsPerPagination]);

  function handleChangePage (event, newPage) {
    updateRowCount(newPage, rowsPerPage);
  }

  function handleChangeRowsPerPage (event) {
    const perPage = parseInt(event.target.value, 10);
    updateRowCount(0, perPage);
  }

  return (
    <TablePagination
      rowsPerPageOptions={rowsPerPageOptions}
      component="div"
      count={tableLength}
      rowsPerPage={rowsPerPage}
      page={page}
      onChangePage={handleChangePage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
      onchange
    />
  );
}
